<template>
  <el-dialog title="提示" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
    <div slot="title" style="display: flex;align-items: center;">
      <div style="position: absolute;display: flex;align-items: center;">
        <div style="font-size: 20px;color: #0E193B;">{{ current.CarNo }}</div>
        <div style="font-size: 12px;color: #0E193B;margin-left: 15px;">{{ current.UpdateTime }}</div>
      </div>
      <div style="color: #0E193B;font-weight: bold;font-size: 20px;flex: 1;">{{ $t('locateVehicle.仪表盘') }}</div>
    </div>
    <div class="vehicle-dashboard">
      <div>
        <div class="vehicle-status-icons">
          <dash_icon v-for="(icon, index) in statusIcons" :key="index" :is-active="icon.isActive"
            :default-icon="icon.defaultIcon" :active-icon="icon.activeIcon" />
          <template v-for="(icon, index) in tempStatusIcons">
            <dash_icon :key="index" v-if="!icon.isActive" :default-icon="icon.defaultIcon" />
            <dash_temp v-else :key="'temp-' + index" :value="icon.value" :unit="icon.unit" :title="icon.title" />
          </template>
        </div>
        <!--图标+仪表盘-->
        <el-row>
          <!--分三列-->
          <el-col :span="8">
            <div style="
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-top: 20px;
            ">
              <div>
                <KLGauge type="speed" :value="parseFloat(current.speed)" :show-in-center="true" :width="240"
                  color="#FF106E" />
              </div>
              <div style="
                font-weight: bold;
                font-size: 22px;
                color: #0f1a3a;
                margin-top: 20px;
              ">
                {{ current.mileage }} km
              </div>
              <div style="font-size: 16px; color: #0f1a3a; margin-top: 10px">
                {{ $t('locateVehicle.总里程') }}
              </div>
            </div>
          </el-col>
          <el-col :span="8" style="text-align: center;">
            <div style="
              height: 40px;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: space-around;
              align-items: center;
              margin-top: 16px;
            ">
              <dash_icon :is-active="current.leftTurnSignal == '1'" default-icon="ic_zuozhuan.png"
                active-icon="ic_zuozhuan_active.png" />

              <div style="font-size: 20px; color: #0e193b">{{ showGear }}</div>
              <dash_icon :is-active="current.rightTurnSignal == '1'" default-icon="ic_youzhuan.png"
                active-icon="ic_youzhuan_active.png" />
            </div>
            <div v-if="this.OilType == '纯电动' || this.OilType == '柴油机'" style="margin-top: 60px">
              <div>
                <img :src="socpic" style="width: 104px; height: 104px" />
              </div>
              <div style="
                margin-top: 25px;
                font-size: 20px;
                color: #0f1a3a;
                font-weight: bold;
              ">
                {{ soc }}%
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div style="
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-top: 30px;
            ">
              <div>
                <!--根据油车和电车判断-->
                <div>
                  <KLGauge :type="showConsumptionPer100kmGaugeType" :value="showConsumptionPer100km"
                    :show-in-center="true" :width="240" color="#FF106E" />
                </div>


              </div>

              <div style="
                font-weight: bold;
                font-size: 22px;
                color: #0f1a3a;
                margin-top: 20px;
              ">
                {{ showTotalConsume() }}
              </div>
              <div style="font-size: 16px; color: #0f1a3a; margin-top: 10px">
                {{ showTotalConsumeName() }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="margin-top: 36px">
        <!--4个大图标-->
        <el-row>
          <!--分三列-->
          <el-col :span="6" v-if="false">
            <circle_icon_value :title="$t('locateVehicle.前/后制动气压')" value="F  0kPa" moreValue="B  0kPa"
              icon="ic_zhidongqiya.png" />
          </el-col>
          <el-col :span="8">
            <circle_icon_value :title="$t('locateVehicle.24V蓄电池电压')" :value="current.battery24VVoltage + ' V'"
              icon="ic_xudianchidianya.png" />
          </el-col>
          <el-col :span="8">
            <circle_icon_value v-if="this.OilType == '纯电动'" :title="$t('locateVehicle.主电机温度')"
              :value="current.mainMotorTemperature + ' °C'" icon="ic_zhudianjiwendu.png" />
            <circle_icon_value v-else :title="$t('locateVehicle.发动机温度')" :value="current.engineTemperature + ' °C'"
              icon="ic_zhudianjiwendu.png" />
          </el-col>
          <el-col :span="8">
            <circle_icon_value v-if="this.OilType == '纯电动'" :title="$t('locateVehicle.主电机转速')"
              :value="current.mainMotorRPM + ' r/min'" icon="ic_zhudianjizhuansu.png" />
            <circle_icon_value v-else :title="$t('locateVehicle.发动机转速')" :value="current.engineRPM + ' r/min'"
              icon="ic_zhudianjizhuansu.png" />
          </el-col>
        </el-row>
      </div>
      <div v-if="this.OilType == '纯电动'" style="margin-top: 36px;margin-left:30px;margin-right:30px;">

        <!--数据状态-->
        <el-row :gutter="16">
          <!--分三列-->
          <el-col :span="6">
            <rect_value :title="$t('locateVehicle.充电状态')" :value="chargeStatus" />
          </el-col>
          <el-col :span="6">
            <rect_value :title="$t('locateVehicle.电动机电压')" :value="current.motorVoltage + ' V'" />
          </el-col>
          <el-col :span="6">
            <rect_value :title="$t('locateVehicle.电动机电流')" :value="current.motorCurrent + ' A'" />
          </el-col>
          <!-- <el-col :span="6"><rect_value title="电动机状态" value="放电" /> </el-col> -->
        </el-row>
      </div>
    </div>

  </el-dialog>

</template>

<script>
import dash_icon from "./dash_icon.vue";
import dash_temp from "./dash_temp.vue";
import circle_icon_value from "./circle_icon_value.vue";
import rect_value from "./rect_value.vue";
import KLGauge from "@/components/KLGauge";
import { QuerySwitchStatus } from "@/http/vehicle";
import { convertGasUnit } from "@/utils/longyi";

export default {
  components: { dash_icon, dash_temp, KLGauge, circle_icon_value, rect_value },
  data() {
    return {
      // vehicleId: "100844",//电车
      vehicleId: "",//油车

      //当前的状态
      current: {

      },
      OilType: "纯电动",

      dialogVisible: false,
      soc: 0,
      recharge: 0, //是否在充电
      timer: null, // 添加定时器变量
      statusIcons: [
        {
          isActive: false,
          defaultIcon: "ic_yuanguangdeng.png",
          activeIcon: "ic_yuanguangdeng_active.png",
        },
        {
          isActive: false,
          defaultIcon: "ic_jinguangdeng.png",
          activeIcon: "ic_jinguangdeng_active.png",
        },
        {
          isActive: false,
          defaultIcon: "ic_qianwudeng.png",
          activeIcon: "ic_qianwudeng_active.png",
        },
        {
          isActive: false,
          defaultIcon: "ic_houwudeng.png",
          activeIcon: "ic_houwudeng_active.png",
        },
        {
          isActive: false,
          defaultIcon: "ic_chemen.png",
          activeIcon: "ic_chemen_active.png",
        },
        {
          isActive: false,
          defaultIcon: "ic_tingche.png",
          activeIcon: "ic_tingche_active.png",
        },
        {
          isActive: false,
          defaultIcon: "ic_zhileng.png",
          activeIcon: "ic_zhileng_active.png",
        },
        // {
        //   isActive: false,
        //   defaultIcon: "ic_zhire.png",
        //   activeIcon: "ic_zhire_active.png",
        // },
      ],
      tempStatusIcons: [
        // {
        //   isActive: false,
        //   defaultIcon: "ic_chewaiwendu.png",
        //   value: "25",
        //   unit: "℃",
        //   title: "车外温度",
        // },
        // {
        //   isActive: true,
        //   defaultIcon: "ic_cheneiwendu.png",
        //   value: "25",
        //   unit: "℃",
        //   title: "车内温度",
        // },
      ],
    };
  },
  computed: {
    showConsumptionPer100km() {
      //百公里能耗
      if (this.OilType == '纯电动') {
        return parseFloat(this.current.elecConsumptionPer100km)
      }
      else if (this.OilType == '气体机') {
        //根据用户设置的单位，进行转换
        // return 70;
      
        return parseFloat( convertGasUnit(parseFloat(this.current.gasConsumptionPer100km), this.$store.getters.gasUnit))
      }
      else if (this.OilType == '柴油机') {
        return parseFloat(this.current.oilConsumptionPer100km)
      } else {
        return 0;
      }
    },
    showConsumptionPer100kmGaugeType() {
      //根据不同的能源类型，显示对应仪表盘的背景
      if (this.OilType == '纯电动') {
        return 'consumptionPer100km_eng'
      }
      else if (this.OilType == '气体机') {
        if(this.$store.getters.gasUnit == 'm3'){
          return 'consumptionPer100km_qiti_m3'//todo 气体机的仪表盘
        }
        return 'consumptionPer100km_qiti_kg'//todo 气体机的仪表盘
      }
      else {
        return 'consumptionPer100km'
      }
    },
    chargeStatus() {
      //用can的数据源
      switch (this.current.chargeStatus) {
        case "0":
          return this.$t("locateVehicle.未充电");
        case "1":
          return this.$t("locateVehicle.充电准备");
        case "2":
          return this.$t("locateVehicle.恒流充电");
        case "3":
          return this.$t("locateVehicle.恒压充电");
        case "4":
          return this.$t("locateVehicle.充电结束");
        case "5":
          return this.$t("locateVehicle.正在充电");
        case "5":
          return this.$t("locateVehicle.充电故障");
        default:
          return "--";
      }
    },

    showGear() {
      if (this.OilType == "纯电动") {
        switch (this.current.elecGear) {
          case "1": return this.$t("locateVehicle.前进挡");
          case "2": return this.$t("locateVehicle.后退挡");
          case "4": return this.$t("locateVehicle.空挡");
          case "8": return this.$t("locateVehicle.P挡");
          default: return this.$t("locateVehicle.未知");
        }

      }
      else {
        switch (this.current.gear) {
          case "0": return this.$t("locateVehicle.空档");
          case "1": return this.$t("locateVehicle.前进挡");
          case "2": return this.$t("locateVehicle.后退挡");
          case "3": return this.$t("locateVehicle.停止");
          case "4": return this.$t("locateVehicle.驻车");
          default: return this.$t("locateVehicle.未知");
        }
      }
    },
    socpic() {
      if (this.OilType == "纯电动") {
        if (this.recharge == 1) {
          return require("@/assets/images/ic_dianliang_chogndian.png");
        }
        if (this.soc >= 50) {
          return require("@/assets/images/ic_dianliang_100.png");
        }
        if (this.soc >= 20) {
          return require("@/assets/images/ic_dianliang_80.png");
        }
        return require("@/assets/images/ic_dianliang_0.png");
      }
      else if (this.OilType == "柴油机") {
        if (this.soc >= 50) {
          return require("@/assets/images/ic_youliang_100.png");
        }
        if (this.soc >= 20) {
          return require("@/assets/images/ic_youliang_80.png");
        }
        return require("@/assets/images/ic_youliang_0.png");
      }
      else if (this.OilType == "气体机") {
        if (this.soc >= 50) {
          return require("@/assets/images/ic_qiliang_100.png");
        }
        if (this.soc >= 20) {
          return require("@/assets/images/ic_qiliang_80.png");
        }
        return require("@/assets/images/ic_qiliang_0.png");
      }
    },
  },
  mounted() {
    this.queryData();

  },
  //页面显示的时候进行定时器
  activated() {
    this.timer = setInterval(() => {
      this.queryData();
    }, 15000);
  },


  beforeDestroy() {
    // 页面关闭时清除定时器
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    showTotalConsume() {
      //{{ this.OilType == '纯电动' ? current.totalElecConsume + ' kW·h' : current.totalOilConsume + ' L' }}
      //显示总能耗
      if (this.OilType == '纯电动') {
        return this.current.totalElecConsume + ' kW·h'
      }
      else if (this.OilType == '气体机') {
        //根据用户设置的单位，进行转换
        console.log(this.$store.getters.gasUnit)
        return convertGasUnit(this.current.totalGasConsume, this.$store.getters.gasUnit) + ' ' +( this.$store.getters.gasUnit==='m3'?'m³':this.$store.getters.gasUnit)//todo 气体机的能耗
      }
      else if (this.OilType == '柴油机') {
        //油耗
        return this.current.totalOilConsume + ' L'
      }
      else {
        return "--"
      }
    },
    showTotalConsumeName() {
      if (this.OilType == '纯电动') {
        return this.$t('locateVehicle.总电耗')
      }
      else if (this.OilType == '气体机') {
        return this.$t('locateVehicle.总气耗')
      }
      else if (this.OilType == '柴油机') {
        return this.$t('locateVehicle.总油耗')
      }
      else {
        return "--"
      }
    },
    show(vehicleId) {
      this.vehicleId = vehicleId;
      this.queryData();
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },


    queryData() {
      if (!this.vehicleId) {
        return;
      }

      //查询车辆数据 1 新能源 2 传统车 
      QuerySwitchStatus({
        VehicleID: this.vehicleId,

      }).then((res) => {
        // console.log(res.data);
        if (res.code == 200) {
          this.current = res.data;

          //根据车辆类型进行切换
          this.OilType = res.data.OilType;
          this.soc = this.OilType == "纯电动" ? parseInt(res.data.soc) : (parseFloat(res.data.oilPercent) * 0.4).toFixed(1);

          //(parseFloat(res.OilPercent) * 0.4).toFixed(1);
          this.statusIcons = [
            {
              isActive: this.current.highBeam == "1",
              defaultIcon: "ic_yuanguangdeng.png",
              activeIcon: "ic_yuanguangdeng_active.png",
            },
            {
              isActive: this.current.lowBeam == "1",
              defaultIcon: "ic_jinguangdeng.png",
              activeIcon: "ic_jinguangdeng_active.png",
            },
            {
              isActive: this.current.frontFogLight == "1",
              defaultIcon: "ic_qianwudeng.png",
              activeIcon: "ic_qianwudeng_active.png",
            },
            {
              isActive: this.current.rearFogLight == "1",
              defaultIcon: "ic_houwudeng.png",
              activeIcon: "ic_houwudeng_active.png",
            },
            {
              isActive: this.current.door1 == "1",
              defaultIcon: "ic_chemen.png",
              activeIcon: "ic_chemen_active.png",
            },
            {
              isActive: this.current.parkingBrake == "1",
              defaultIcon: "ic_tingche.png",
              activeIcon: "ic_tingche_active.png",
            },
            {
              isActive: this.current.ac == "1",
              defaultIcon: "ic_zhileng.png",
              activeIcon: "ic_zhileng_active.png",
            },
            // {
            //   isActive: false,
            //   defaultIcon: "ic_zhire.png",
            //   activeIcon: "ic_zhire_active.png",
            // },
          ]
        }
      });

    },
    handleClose(done) {
      this.dialogVisible = false;

      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => { });
    }
  },
};
</script>

<style scoped>
.vehicle-dashboard {
  padding: 20px;
  background-color: #fff;
}

.vehicle-status-icons {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  align-content: center;
  flex-direction: row;
}
</style>
